function bytesToBase64(bytes) {
  let binary = "";
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary);
}

function getPinEncryptKeyBytes() {
  const raw =
    typeof process !== "undefined" &&
    process.env &&
    process.env.REACT_APP_PIN_ENCRYPT_KEY;
  if (!raw) return null;

  try {
    const decoded = Uint8Array.from(atob(raw), (c) => c.charCodeAt(0));
    if (decoded.length === 32) return decoded;
  } catch (_) {
    // fall through to utf8
  }

  const utf8 = new TextEncoder().encode(raw);
  return utf8.length === 32 ? utf8 : null;
}

let cryptoKeyPromise = null;

function getCryptoKey() {
  if (!cryptoKeyPromise) {
    const keyBytes = getPinEncryptKeyBytes();
    if (!keyBytes) {
      cryptoKeyPromise = Promise.resolve(null);
    } else {
      cryptoKeyPromise = window.crypto.subtle.importKey(
        "raw",
        keyBytes,
        { name: "AES-GCM" },
        false,
        ["encrypt"]
      );
    }
  }
  return cryptoKeyPromise;
}

export async function encryptPinPayload(text) {
  const key = await getCryptoKey();
  if (!key) {
    throw new Error("PIN encryption key is not configured.");
  }

  const payload =
    typeof text === "string" ? text : JSON.stringify(text != null ? text : {});
  const iv = window.crypto.getRandomValues(new Uint8Array(12));
  const encoded = new TextEncoder().encode(payload);
  const encrypted = await window.crypto.subtle.encrypt(
    { name: "AES-GCM", iv, tagLength: 128 },
    key,
    encoded
  );

  const encryptedBytes = new Uint8Array(encrypted);
  const tag = encryptedBytes.slice(encryptedBytes.length - 16);
  const ciphertext = encryptedBytes.slice(0, encryptedBytes.length - 16);

  return [iv, tag, ciphertext].map(bytesToBase64).join(".");
}
